import { configureStore } from '@reduxjs/toolkit';
import detailsSlice from '../features/details/detailsSlice';
import filterSlice from '../features/filterSlice/filterSlice';
import postSlice from '../features/posts/postSlice';
import relatedPostsSlice from '../features/relatedPosts/relatedPostsSlice';

export const store = configureStore({
  reducer: {
    posts: postSlice,
    details: detailsSlice,
    relatedPosts: relatedPostsSlice,
    filter: filterSlice
  },
});
